import React from 'react';
import cx from 'classnames';

import SmartLink from '../SmartLink';
import Link from '../Link';
import TagsList from '../../app/components/CheckupAccordion/TagsList';
import TypographySwitcher from '../TypographySwitcher';

import { ReactComponent as UncheckedIcon } from '../../assets/svg/checkbox-with-grey-border.svg';
import { ReactComponent as CheckedIcon } from '../../assets/svg/checkbox-checked-purple.svg';
import { ReactComponent as LockedIcon } from '../../assets/svg/lock-icon.svg';

import { Body2 } from '../Typography';

import styles from './index.module.scss';

export interface ProductCardProps {
  imageUrl: string;
  imageAlt?: string;
  title: string;
  price: string;
  description: string;
  tags?: string[];
  buttonUrl: string;
  buttonText: string;
  isMultipleProducts: boolean;
  isChecked: boolean;
  className?: string;
  contentClassName?: string;
  variantId: string;
  onToggle: (variantId: string) => void;
  isLocked?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({
  imageUrl,
  imageAlt,
  title,
  price,
  description,
  tags,
  buttonUrl,
  buttonText,
  isMultipleProducts,
  isChecked,
  className,
  contentClassName,
  variantId,
  onToggle,
  isLocked,
}) => {
  const toggleCheckbox = () => {
    onToggle(variantId);
  };

  const isTagsAvailable = tags && tags.length > 0;

  return (
    <div className={cx(styles.wrapper, className)}>
      <div className={cx(styles.content, contentClassName)}>
        <div className={styles.imageAndTextWrapper}>
          {isMultipleProducts ? (
            <button
              onClick={toggleCheckbox}
              className={cx(styles.imageWrapper, {
                [styles.button]: isMultipleProducts,
                [styles.locked]: isLocked,
              })}
            >
              <img className={styles.image} src={imageUrl} alt={imageAlt} />
              {isChecked && !isLocked && (
                <CheckedIcon className={styles.checkbox} />
              )}
              {!isChecked && !isLocked && (
                <UncheckedIcon className={styles.checkbox} />
              )}
              {isLocked && <LockedIcon className={styles.lockedIcon} />}
            </button>
          ) : (
            <div className={styles.imageWrapper}>
              <img className={styles.image} src={imageUrl} alt={imageAlt} />
            </div>
          )}

          <div className={styles.textWrapper}>
            <TypographySwitcher
              mobile='subtitle2'
              tablet='subtitle1'
              desktop='subtitle1'
              className={styles.title}
            >
              {title}
            </TypographySwitcher>
            {isTagsAvailable ? (
              <TagsList tags={tags.join(', ')} />
            ) : (
              <TypographySwitcher
                mobile='body2'
                tablet='subtitle1'
                desktop='subtitle1'
                className={styles.price}
              >
                {price}
              </TypographySwitcher>
            )}

            <Body2 className={styles.description}>
              {description}{' '}
              {buttonText && buttonUrl && !isTagsAvailable && (
                <SmartLink className={styles.link} to={buttonUrl}>
                  {buttonText}
                </SmartLink>
              )}
            </Body2>
          </div>
        </div>

        {tags && tags.length > 0 && (
          <div className={styles.priceAndButtonWrapper}>
            <TypographySwitcher
              mobile='body2'
              tablet='subtitle1'
              desktop='subtitle1'
              className={styles.price}
            >
              {price}
            </TypographySwitcher>
            <Link variant='outlinedGradient' size='small' url={buttonUrl}>
              {buttonText}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
